var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "location-box__btns" },
    [
      _vm.showOrder
        ? _c("Button", {
            attrs: {
              text: _vm.$t("locations.orderButton"),
              type: "button",
              level: "primary",
              small: ""
            },
            on: { click: _vm.onOrder }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showReservation
        ? _c("Button", {
            attrs: {
              text: _vm.$t("locations.reserveButton"),
              type: "button",
              level: "primary",
              small: ""
            },
            on: { click: _vm.onReservation }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isLunchPerMailActive
        ? _c(
            "div",
            { staticClass: "location-box__lunchmail" },
            [
              _c("Button", {
                attrs: {
                  href: _vm.$t("locations.lunchMailUrl", { id: _vm.id }),
                  level: "tertiary",
                  text: _vm.$t("locations.lunchMailButton"),
                  arrow: ""
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }